export default "__VITE_ASSET__DkcEIqmx__"